import { render, staticRenderFns } from "./ShipmentsList.vue?vue&type=template&id=3491d4f6&scoped=true"
import script from "./ShipmentsList.vue?vue&type=script&lang=js"
export * from "./ShipmentsList.vue?vue&type=script&lang=js"
import style0 from "./ShipmentsList.vue?vue&type=style&index=0&id=3491d4f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3491d4f6",
  null
  
)

export default component.exports